
import ReferredUsers from "@/views/pages/Admin/cooperationInSale/ReferredUsers.vue";
import ManagementPaymentRequestList from "@/views/pages/Admin/cooperationInSale/ManagementPaymentRequestList.vue";
import UsersHasSubset from "@/views/pages/Admin/cooperationInSale/UsersHasSubset.vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "kt-management-cooperation-in-sale",
  components: {
    ReferredUsers,
    ManagementPaymentRequestList,
    UsersHasSubset,
  },
  setup() {
    return {};
  },
});
